'use client';
import { useState } from 'react';
import { DialogDescription, DialogTrigger } from '@radix-ui/react-dialog';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import Loader from '../../ui/loader';

const ReleaseOrderModal = ({ Texts, releaseOrder }: any) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleReleaseOrder = async () => {
    setLoading(true);
    await releaseOrder();
    setLoading(false);
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="underline">{Texts.releaseOrder}</DialogTrigger>
      <DialogContent className="max-w-[520px] bg-white sm:rounded-md">
        {loading && <Loader />}
        <DialogHeader>
          {/* chng-text-25px */}
          <DialogTitle className="text-2xl font-bold">
            <div className="text-2xl font-bold">{Texts.releaseOrder}</div>
          </DialogTitle>
          <DialogDescription>
            <p className="mb-4 text-base font-normal">
              {Texts.releaseOrderHeading}{' '}
              <span className="font-bold text-scarletRed">{Texts.releaseOrderSubHeading}</span>?{' '}
            </p>
          </DialogDescription>
        </DialogHeader>
        <section className="flex justify-start gap-4">
          <Button
            className="rounded-md bg-deepBlue p-4 text-white"
            onClick={() => {
              handleReleaseOrder();
            }}
          >
            {Texts.releaseOrder}
          </Button>
          <Button className="p-0 underline" onClick={() => setOpen(false)}>
            {Texts.cancel}
          </Button>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default ReleaseOrderModal;
